import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";

// import moment from "moment"
import { format } from "date-fns";

import Report from "./components/report";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import FormatAlignLeftIcon from "@material-ui/icons/FormatAlignLeft";
import FormatAlignCenterIcon from "@material-ui/icons/FormatAlignCenter";
import ViewColumnIcon from "@material-ui/icons/ViewColumn";
import TableChartIcon from "@material-ui/icons/TableChart";
import StorageIcon from "@material-ui/icons/Storage";
import { has_selected_filter } from "./../../utilities/_has_selected_filter";
import {
  relational_filter_list,
  non_relational_filter_list_dash_agency,
} from "./../../utilities/_filter_list_builder";

import FilterElement from "./../layout/FilterElement";
import Calendar from "./../layout/Calendar";

import { updateFilterElement } from "../../store/actions/filterElementAction";
import { signOut } from "../../store/actions/authAction";

import "./style.css";
import "./../layout/styles/filter.css";
import Footer from "../Footer/Footer";
import ToggleButtonGroupBkash from "../Shared/ToggleButtonGroupBkash";

const online_scope_reports = [
  {
    name: "Lead status report",
    url: `/api/online/v1/generate-lead-report`,
    filename: "online_lead",
    file_type: "csv",
  },
  {
    name: "Online call report",
    url: `/api/online/v1/generate-call-report`,
    filename: "online_call",
    file_type: "xlsx",
  },
  {
    name: "Online MAO performance report",
    url: `/api/online/v1/generate-mao-performance-report`,
    filename: "online_mao_performance",
    file_type: "xlsx",
  },
  {
    name: "Email history report",
    url: `/api/online/v1/email-history-report`,
    filename: "email_history",
    file_type: "xlsx",
  },
];

const outlet_calls_by_merchandisersList = [
  {
    name: "Raw Data Report",
    url: `/api/reports/v1/raw-data-report`,
    filename: "raw_data",
    file_type: "zip",
  },
  {
    name: "Merchant raw KYC Report",
    url: `/api/reports/v3/get-raw-merchant-kyc-data`,
    filename: "raw_merchant_kyc",
    file_type: "zip",
    statusKey: "raw-merchant-kyc-data_super-admin",
    isGeneratable: true,
    userTypes: ["bkash-super-user"],
  },
  {
    name: "Employee to Supervisor Mapping",
    url: `/api/reports/v3/employee-supervisor-mapping`,
    filename: "employee_to_supervisor_mapping",
    file_type: "xlsx",
    userTypes: ["bkash-super-user"],
  },
  {
    name: "Acquisition Target vs Achievement Report",
    url: `/api/reports/v3/acquisition-target-vs-achivement`,
    filename: "acquisition_target_vs_achievement",
    file_type: "xlsx",
    userTypes: ["bkash-super-user"],
  },
  {
    name: "Route Target vs Achievement Report",
    url: `/api/reports/v3/route-target-vs-achievement`,
    filename: "route_target_vs_achievement",
    file_type: "xlsx",
    userTypes: ["bkash-super-user"],
  },
  {
    name: "Lat Long Report Merchandiser",
    url: `/api/reports/v3/get-lat-lng-report-merchant`,
    filename: "lat_lng_merchant",
    file_type: "xlsx",
  },
  {
    name: "MDO Performance Report",
    url: `/api/reports/v1/mdo-wise-report`,
    filename: "mdo_data",
    file_type: "xlsx",
  },

  {
    name: "Assisted eKYC Report",
    url: `/api/ekyc/v1/assisted-ekyc-report`,
    filename: "assisted_ekyc_data",
    file_type: "xlsx",
  },

  {
    name: "Merchant Raw Transaction report ",
    url: `/api/reports/v3/get-raw-merchant-trn-data`,
    filename: "raw_merchant_transaction",
    file_type: "zip",
    userTypes: ["bkash-super-user"],
  },
  {
    name: "Lat Long Report",
    url: `/api/reports/v3/get-lat-lng-report`,
    filename: "lat_lng_report",
    file_type: "xlsx",
    // userTypes: ["bkash-super-user"],
  },

  {
    name: "MMO Call Summery Report",
    url: `/api/reports/v3/mmo-call-summery-report`,
    filename: "mmmo_call_summary",
    file_type: "xlsx",
    userTypes: ["bkash-super-user"],
  },

  {
    name: "Territory Summary Report",
    url: `/api/reports/v3/territory-summery-report`,
    filename: "territory_summary_report",
    file_type: "xlsx",
    userTypes: ["bkash-super-user"],
  },
  {
    name: "MMO Visit Summary Report",
    url: `/api/reports/v3/mmo-visit-summery-report`,
    filename: "MMO_visit_summary_report",
    file_type: "xlsx",
    userTypes: ["bkash-super-user"],
  },
  {
    name: "Merchant Call Report",
    url: `/api/reports/v2/merchant-call-report`,
    filename: "merchant_call",
    file_type: "xlsx",
  },
  {
    name: "Assigned Route Report",
    url: `/api/reports/v3/assigned-route-report`,
    filename: "assigned_route",
    file_type: "xlsx",
  },
  {
    name: "Route Call Report",
    url: `/api/reports/v3/route-call-report`,
    filename: "route_call_report",
    file_type: "xlsx",
  },
  {
    name: "MDO Covid Phase Performance Report",
    url: `/api/reports/v2/mdo-wise-covid-report`,
    filename: "mdo_covid_phase_data",
    file_type: "xlsx",
  },
  {
    name: "KYC Action Report",
    url: `/api/reports/v2/kyc-action-report`,
    filename: "kyc_action_report",
    file_type: "xlsx",
  },
  {
    name: "Attendance Report",
    url: `/api/reports/v3/attendance-report`,
    filename: "attendence_report",
    file_type: "xlsx",
  },
  {
    name: "Daily MMO Performance Report",
    url: `/api/reports/v3/daily-mmo-performance-report`,
    filename: "daily-mmo-performance-report",
    file_type: "xlsx",
    dateRangeLimit: 30,
  },
  {
    name: "Day wise MMO Visit Report",
    url: `/api/reports/v3/mmo-visit-report`,
    filename: "mmo-visit-report",
    file_type: "xlsx",
    dateRangeLimit: 30,
  },
  {
    name: "Active MMO Count Report",
    url: `/api/reports/v3/active-mmo-count-report`,
    filename: "active-mmo-count-report",
    file_type: "xlsx",
    dateRangeLimit: 30,
  },

  {
    name: "MDO Average Performance",
    url: `/api/reports/v3/agency-wise-report`,
    filename: "agency-wise_mdo_average_performance_report",
    file_type: "xlsx",
  },
  // {
  //   name: "Competition Update Report",
  //   url: `/api/reports/v1/competition-update-report`,
  //   filename: "competition_update_report",
  //   file_type: "xlsx",
  // },
  {
    name: "Cumulative Merchant Unique Visit Report",
    url: `/api/reports/v1/cumulative-merchant-unique-visit-summary-report`,
    filename: "cumulative_merchant_unique_visit_summary_report",
    file_type: "xlsx",
  },
  {
    name: "Not Visited Merchant List Report",
    url: `/api/reports/v1/not-visited-merchant-list-report`,
    filename: "not_visited_merchant_list_report",
    file_type: "xlsx",
  },
  {
    name: "Unique Regular Visit Report",
    url: `/api/reports/v1/unique-visit-summary-report`,
    filename: "unique_regular_visit_report",
    file_type: "xlsx",
  },
  {
    name: "Spot Info Report",
    url: `/api/reports/v3/spot-info-report`,
    filename: "spot_info_report_download_at_",
    file_type: "xlsx",
  },
  {
    name: "Spot Mapping Report",
    url: `/api/reports/v3/spot-mapping-report`,
    filename: "spot_mapping_report_download_at_",
    file_type: "xlsx",
  },
  {
    name: "Merchant Report",
    url: `/api/reports/v3/merchant-list-report`,
    filename: "merchant_report_report_download_at_",
    file_type: "zip",
  },
  {
    name: "Merchant Lead Report",
    url: `/api/reports/v3/merchant-lead-report`,
    filename: "merchant_lead_report_download_at_",
    file_type: "xlsx",
  },
  {
    name: "Merchant Last Followup Report",
    url: `/api/reports/v3/merchant-last-visit-report`,
    filename: "merchant_last_followup_report_download_at_",
    file_type: "xlsx",
  },
  {
    name: "Merchant Next Followup Report",
    url: `/api/reports/v3/merchant-followup-report`,
    filename: "merchant_next_followup_report_download_at_",
    file_type: "xlsx",
  },
  {
    name: "Merchant Lead Close Report",
    url: `/api/reports/v3/merchant-lead-close-report`,
    filename: "merchant_lead_close_report",
    file_type: "xlsx",
  },
  {
    name: "Employee information Report",
    url: `/api/reports/v3/mdo-information-report`,
    filename: "employee_mdo_information_report",
    file_type: "xlsx",
  },
  {
    name: "Route Performance Report",
    url: `/api/reports/v3/route-performance-report`,
    filename: "route_performance_report",
    file_type: "xlsx",
  },
  {
    name: "Facematching Report",
    url: `/report/download-selfie-report`,
    module: "facematch",
    filename: "facematching_report",
    file_type: "xlsx",
  },
];

const kam_reports = [
  {
    name: "Raw Data Report",
    url: `reports/v1/raw-data-report`,
    filename: "raw_data_report",
    file_type: "xlsx",
  },
  {
    name: "Not Visited Merchant Report",
    url: `reports/v1/not-visited-merchant-report`,
    filename: "not_visited_merchant_report",
    file_type: "xlsx",
  },
  {
    name: "Unique Merchant Visit Report",
    url: `reports/v1/unique-merchant-visit-report`,
    filename: "unique_merchant_visit_report",
    file_type: "xlsx",
  },
  {
    name: "Cumulative Merchant Visit Report",
    url: `reports/v1/cumulative-merchant-visit-report`,
    filename: "cumulative_merchant_visit_report",
    file_type: "xlsx",
  },
  {
    name: "Servicing Status Report",
    url: `reports/v1/servicing-status-report`,
    filename: "servicing_status_report",
    file_type: "xlsx",
  },
];

const kam_merchant_management_reports = [
  {
    name: "Merchant Management Portal Report",
    url: `reports/v1/mmt/raw-service-report`,
    filename: "mmt_portal_report",
    file_type: "xlsx",
  },
];

class GeneralReports extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: null,
      endDate: null,
      currentPage: null,
      filterElement: null,
      isReportViewCompact: false,
      filter: "general",
    };
  }

  handleReportView = () => {
    this.setState((prevState) => ({
      isReportViewCompact: !prevState.isReportViewCompact,
    }));
  };

  componentDidMount() {
    this.set_data_set();
  }

  componentDidUpdate(prevProps) {
    if (this.props.filterElement !== prevProps.filterElement)
      this.set_data_set();
  }

  set_data_set = () =>
    this.setState({
      currentPage: this.props.currentPage,
      filterElement: this.props.filterElement,
    });

  create_filter_elements = (filter, type) =>
    filter.map((item, index) => (
      <FilterElement
        key={index}
        {...item}
        selectedValue={this.props.filterElement}
        type={type}
      />
    ));

  async remove_all_filter() {
    await this.props.updateFilterElement({
      reports: {
        relational: {},
        non_relational: {},
      },
    });
  }

  filteUserTypePermission = (i) => {
    const user_type = JSON.parse(localStorage.getItem("currUserType"));
    var filterPass = false;
    if (!i.userTypes) return true;
    if (i.userTypes)
      i.userTypes.map((userType) => {
        if (userType === user_type) filterPass = true;
      });
    return filterPass;
  };

  render() {
    const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));
    if (!localUserToken) return <Redirect to="/signin" />;
    const localUserType = JSON.parse(localStorage.getItem("currUserType"));

    let current_time = Date.now().valueOf() / 1000;
    if (this.props.expiration < current_time) this.props.signOut();

    return (
      <div>
        <div
          className={
            JSON.parse(localStorage.getItem("currUserType")) !==
              "agency_user" && this.props.portal !== "kam"
              ? "reports"
              : "full-width-reports"
          }
          style={{ padding: 0 }}
        >
          <div className="page-header">
            <div className="page-heading">
              {/* <div className="page-sub-heading">
                {
                  //moment(this.props.startDate).format("EEE, MMM dd")
                  format(new Date(this.props.startDate), "EEE, MMM dd")
                }{" "}
                to{" "}
                {
                  //moment(this.props.endDate).format("EEE, MMM dd")
                  format(new Date(this.props.endDate), "EEE, MMM dd")
                }
              </div> */}
            </div>
            <div className="page-settings">
              {/*  */}
              <div className="info-report-view">
                {/* <p>compact: {this.state.isReportViewCompact.toString()}</p> */}
                {/* <ToggleButtonGroup
                  value={this.state.isReportViewCompact}
                  exclusive
                  onChange={this.handleReportView}
                  aria-label="text alignment"
                  style={{ marginRight: 10, height: 40 }}
                >
                  <ToggleButton value={true} aria-label="left aligned">
                    <StorageIcon />
                  </ToggleButton>
                  <ToggleButton value={false} aria-label="left aligned">
                    <ViewColumnIcon />
                  </ToggleButton>
                </ToggleButtonGroup> */}
                {/* <Calendar
                  page={"reports"}
                  startDate={this.props.startDate}
                  endDate={this.props.endDate}
                /> */}
              </div>
              {JSON.parse(localStorage.getItem("currUserType")) !==
                "agency_user" &&
                this.props.portal !== "kam" &&
                this.props.filterHide && (
                  <div className="filter-container report-filter">
                    <div className="header">
                      <div className="heading">Select Filter</div>
                      {has_selected_filter(this.props.filterElement) ? (
                        <div className="clear">
                          <button
                            className="active-button"
                            onClick={() => this.remove_all_filter()}
                          >
                            Clear All
                          </button>
                        </div>
                      ) : (
                        <div className="clear">
                          <button
                            className="inactive-button"
                            onClick={() => this.remove_all_filter()}
                            disabled
                          >
                            Clear All
                          </button>
                        </div>
                      )}
                    </div>
                    <div className="body">
                      {localUserType === "agency_user"
                        ? this.create_filter_elements(
                            non_relational_filter_list_dash_agency("reports"),
                            "relational"
                          )
                        : this.create_filter_elements(
                            relational_filter_list("reports"),
                            "relational"
                          )}
                    </div>
                  </div>
                )}
            </div>
          </div>

          {localStorage.getItem("scope") === "online" ? (
            <div className="card-row row">
              {online_scope_reports.map((item, index) => (
                <div key={index} className="card-col col l4 m6 s12">
                  <Report
                    isCompactView={this.state.isReportViewCompact}
                    report={item}
                    // currentPage={this.state.currentPage}
                    filterElement={this.state.filterElement}
                    // actions={this.props.actions}
                  />
                </div>
              ))}
            </div>
          ) : (
            <div
              className="card-row row"
              style={{
                flexDirection: this.state.isReportViewCompact
                  ? "column"
                  : "row",
              }}
            >
              {this.props.portal === "dexter" &&
                outlet_calls_by_merchandisersList
                  .filter(this.filteUserTypePermission)
                  .map((item, index) => (
                    <div
                      key={index}
                      className="card-col col l4 m6 s12"
                      style={{
                        width: this.state.isReportViewCompact ? "100%" : "25%",
                        marginTop: this.state.isReportViewCompact ? 0 : 16,
                        minWidth: 300,
                      }}
                    >
                      <Report
                        report={item}
                        isCompactView={this.state.isReportViewCompact}
                        // currentPage={this.state.currentPage}
                        filterElement={this.state.filterElement}
                        // actions={this.props.actions}
                      />
                    </div>
                  ))}

              {this.props.portal === "kam" &&
                this.props.userType === "merchant_management" &&
                kam_merchant_management_reports.map((item, index) => (
                  <div
                    key={index}
                    className="card-col col l4 m6 s12"
                    style={{
                      width: this.state.isReportViewCompact ? "100%" : "25%",
                      marginTop: this.state.isReportViewCompact ? 0 : 16,
                      minWidth: 300,
                    }}
                  >
                    <Report
                      report={item}
                      isCompactView={this.state.isReportViewCompact}
                      currentPage={this.state.currentPage}
                      filterElement={this.state.filterElement}
                      // actions={this.props.actions}
                    />
                  </div>
                ))}

              {this.props.portal === "kam" &&
                this.props.userType === "super_user" &&
                kam_reports.map((item, index) => (
                  <div
                    key={index}
                    className="card-col col l4 m6 s12"
                    style={{
                      width: this.state.isReportViewCompact ? "100%" : "25%",
                      marginTop: this.state.isReportViewCompact ? 0 : 16,
                      minWidth: 300,
                    }}
                  >
                    <Report
                      report={item}
                      isCompactView={this.state.isReportViewCompact}
                      currentPage={this.state.currentPage}
                      filterElement={this.state.filterElement}
                      // actions={this.props.actions}
                    />
                  </div>
                ))}

              {this.props.portal === "kam" &&
                this.props.userType === "app_user" &&
                kam_reports.map((item, index) => (
                  <div
                    key={index}
                    className="card-col col l4 m6 s12"
                    style={{
                      width: this.state.isReportViewCompact ? "100%" : "25%",
                      minWidth: 300,
                    }}
                  >
                    <Report
                      report={item}
                      isCompactView={this.state.isReportViewCompact}
                      currentPage={this.state.currentPage}
                      filterElement={this.state.filterElement}
                      // actions={this.props.actions}
                    />
                  </div>
                ))}
            </div>
          )}
        </div>
        <Footer />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  let startDate = state.calendar.reports
    ? state.calendar.reports.startDate
    : state.calendar.default.startDate;
  let endDate = state.calendar.reports
    ? state.calendar.reports.endDate
    : state.calendar.default.endDate;
  let currentPage = state.page.currentPage;
  let filterElement = state.filterElement.reports
    ? state.filterElement.reports
    : state.filterElement.default;
  let filterHide = state.filter.filterHide;

  let expiration = state.auth.authToken
    ? state.auth.authToken.expiration
    : 20000;

  let portal = state.auth.authToken ? state.auth.authToken.portal : "dexter";

  let userType = state.auth.authToken ? state.auth.authToken.type : null;

  // console.log(actions)

  return {
    startDate,
    endDate,
    currentPage,
    filterElement,
    filterHide,
    expiration,
    portal,
    userType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateFilterElement: (filter) => dispatch(updateFilterElement(filter)),
    signOut: () => dispatch(signOut()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GeneralReports);
